import EfAniSticky, { EfAniStickyItem } from '@elem/ui/ef-ani-sticky';
import EfSection from '@elem/ui/ef-section';
import SectionLRA from '../SectionLRA';
import SectionLRB from '../SectionLRB';
import SectionLRC from '../SectionLRC';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionC');
    return (
        <div className={`${styles.TheComp} ani-sticky-b`}>
            <EfSection label={t('label')} title={t('title')} desc={t('desc')} />
            <EfAniSticky scrollPercent={[0.3, 0.9, 1]}>
                <EfAniStickyItem>
                    <SectionLRA />
                </EfAniStickyItem>
                <EfAniStickyItem>
                    <SectionLRB />
                </EfAniStickyItem>
                <EfAniStickyItem>
                    <SectionLRC />
                </EfAniStickyItem>
            </EfAniSticky>
        </div>
    );
}
